import React, { useState } from "react";
import "./Step1.scss";
import SubmitButton from "../SubmitButton/SubmitButton";
import { AiOutlineInfoCircle } from "react-icons/ai";
import Step2Popup from "../Step2Popup/Step2Popup";
import WindowButton from "../WindowButton/WindowButton";
import CustomRadio from "../CustomRadio/CustomRadio";
import PustsoPlusButton from "../PutsoPlusButton/PutsoPlusButton";
import WindowTypeButton from "../WindowTypeButton/WindowTypeButton";
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";
import { sumOfWindows } from "../../../helpers/bookingUtils";
import { isMobile } from "react-device-detect";

const Step1 = ({
  onSubmit,
  choosenService,
  price,
  setPrice,
  howOften,
  setHowOften,
  windowsPages,
  setWindowsPages,
  optional,
  setOptional,
  windows,
  setWindows,
}) => {
  const [popupVisible, setPopupVisible] = useState(false);

  const handleIncrease = (num) => {
    setWindows((p) => ({ ...p, [num]: p[num] + 1 }));
  };

  const handleDecrease = (num) => {
    if (windows[num] === 0) return;

    setWindows((p) => ({ ...p, [num]: p[num] - 1 }));
  };

  return (
    <>
      {popupVisible && (
        <Step2Popup
          choosenService={choosenService}
          onClose={() => setPopupVisible(false)}
          active={popupVisible}
        />
      )}

      <div className="white-shadow">
        <h1 className="heading">Hur ofta ska vi putsa?</h1>
        <p className="text-main-600 text-sm mt-3 mb-8">
          Tecknar du årsavtal får du rabatterat pris.
        </p>
        <CustomRadio
          title="Engångsputs"
          description="fönsterputs av samtliga fönster och sidor"
          checked={howOften}
          onClick={setHowOften}
          idToScroll="windows"
        />
        <CustomRadio
          title="Två gånger per år"
          description="fönsterputs av samtliga fönster och sidor"
          mostPopular
          checked={howOften}
          onClick={setHowOften}
          idToScroll="windows"
        />
        <PustsoPlusButton
          checked={howOften}
          onClick={setHowOften}
          idToScroll="windows"
        />
        <CustomRadio
          title="Anpassad"
          description="Fyll i bokningsförfrågan så kontaktar vi dig och hittar en flexibel lösning"
          checked={howOften}
          onClick={setHowOften}
          idToScroll="windows"
        />
      </div>

      <div className="Step1 white-shadow mt-6" id="windows">
        <h1 className="heading">Välj typ av fönster och ange antal</h1>
        <p className="description flex items-center">
          <AiOutlineInfoCircle
            className="mr-1"
            style={{ minWidth: 20, height: "auto" }}
          />
          Varje del av ett “fönsterparti” som går att öppna separat räknas som
          ett fönster.
        </p>
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-6">
          <WindowButton
            windowType={1}
            state={windows["1"]}
            handleDecrease={() => handleDecrease("1")}
            handleIncrease={() => handleIncrease("1")}
          />
          <WindowButton
            windowType={2}
            state={windows["2"]}
            handleDecrease={() => handleDecrease("2")}
            handleIncrease={() => handleIncrease("2")}
          />
          <WindowButton
            windowType={4}
            state={windows["4"]}
            handleDecrease={() => handleDecrease("4")}
            handleIncrease={() => handleIncrease("4")}
          />
          <WindowButton
            windowType={6}
            state={windows["6"]}
            handleDecrease={() => handleDecrease("6")}
            handleIncrease={() => handleIncrease("6")}
          />
          <WindowButton
            windowType={8}
            state={windows["8"]}
            handleDecrease={() => handleDecrease("8")}
            handleIncrease={() => handleIncrease("8")}
          />
          <WindowButton
            state={windows.other}
            handleDecrease={() => handleDecrease("other")}
            handleIncrease={() => handleIncrease("other")}
          />
        </div>
      </div>

      {(howOften === "Engångsputs" || howOften === "Två gånger per år") && (
        <div className="white-shadow mt-6">
          <h1 className="heading mb-3">Hur många sidor ska putsas?</h1>
          <div className="grid sm:grid-cols-2 gap-6">
            <WindowTypeButton
              windowType={2}
              handleClick={() => {
                setWindowsPages(2);
                isMobile &&
                  document
                    .getElementById("optional")
                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              active={windowsPages === 2}
            />
            <WindowTypeButton
              windowType={4}
              handleClick={() => {
                setWindowsPages(4);
                isMobile &&
                  document
                    .getElementById("optional")
                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              active={windowsPages === 4}
            />
          </div>
        </div>
      )}
      <div className="white-shadow mt-6" id="optional">
        <h1 className="heading mb-3">Något du vill lägga till?</h1>
        <CustomCheckbox
          title="Nej, tack!"
          optionNone
          description="Gå vidare till nästa steg"
          checked={optional.some((el) => el === "Nej, tack!")}
          optional={optional}
          setOptional={setOptional}
        />
        <CustomCheckbox
          title="Karmtvätt"
          description="Rengöring av fönsterkarmar och fönsterbågar"
          checked={optional.some((el) => el === "Karmtvätt")}
          optional={optional}
          setOptional={setOptional}
        />
        <CustomCheckbox
          title="Fönsterbleck"
          description="Rengöring av fönsterbleck"
          checked={optional.some((el) => el === "Fönsterbleck")}
          optional={optional}
          setOptional={setOptional}
        />
        <CustomCheckbox
          title="Höjdtillägg"
          description="När fönsternas överkant är högre än 2,8m över markplan"
          checked={optional.some((el) => el === "Höjdtillägg")}
          optional={optional}
          setOptional={setOptional}
        />
      </div>

      <div className="buttons-flex">
        <SubmitButton
          isValid={
            sumOfWindows(windows) !== 0 && optional?.length > 0 && windowsPages
          }
          text="Välj datum"
          onClick={onSubmit}
        />
      </div>
    </>
  );
};

export default Step1;
